<template>
  <form @submit="next" style="padding:10px;">
    <label class="labelControl">Declaro que el préstamo que se me otorgará será para beneficio de:</label>
    <div class="grid grid-cols-12 gap-4">
      <div class="md:col-start-5 md:col-end-7 col-start-5 col-end-9 md:row-start-1">
        <input type="button" value="Yo mismo" class="buttonWithoutBackground"
        v-bind:style="{backgroundColor: myself == true ? activeColorBackground : inactiveColorBackground, 
          color: myself == true ? activeColorText : inactiveColorText}" v-on:click="myself = true" >
      </div>
      <div class="md:col-start-7 md:col-end-9 col-start-5 col-end-9 md:row-start-1 row-start-2">
        <input type="button" value="Un tercero" class="buttonWithoutBackground"
          v-bind:style="{backgroundColor: myself == false ? activeColorBackground : inactiveColorBackground, 
          color: myself == false ? activeColorText : inactiveColorText}" v-on:click="myself = false" >
      </div>
      <div class="col-start-5 col-end-9" v-show="myself == false">
        <label class="labelControl">Relación conmigo</label>
        <select name="select" class="form-control inputControl">
        </select>
      </div>
      <div class="col-start-5 col-end-9">
        <button class="buttonNext">Continuar</button>
      </div>
      <div class="col-start-5 col-end-9" v-if="showBackButton == '1'">
        <input type="button" value="Atrás" v-on:click="goToBack" class="buttonBack" />
      </div>
    </div>
  </form>
</template>

<script>
import MenuLateral from "@/components/Cuenta/MenuLateral.vue";
import Loading from "@/components/Loading/VueLoading.vue";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      isLoading: false,
      myself: null,
      activeColorText: "#fff",
      inactiveColorText: "#000",
      activeColorBackground: "#223635",
      inactiveColorBackground: "#fff",
    };
  },
  name: "Declaracion",
  components: {
    MenuLateral,
    Loading,
  },
  props: ['tab','tabBack','step', ,'stepBack','action','url','showBackButton'],
  async mounted() {},
  async beforeMount() {
  },
  methods: {
    next() {
      this.$emit('event-tab', {tab: this.tab,title:'',url:'',step:this.step});
    },
    goToBack() {
      if (this.action == "reedirect") {
        // window.location.href = this.url;
        this.$router.push({path:`${this.url}`});
      } else {
        this.$emit('event-tab-back', {tab: this.tab, tabBack: this.tabBack, title: '',url:'',step:this.step, stepBack:this.stepBack});
      }
    }
  },
};
</script>

<style>
.mycontent-left {
  border-right: 1px dashed #333;
  height: 250px;
}
#panel {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

form {
  text-align:center;
}

.form-group {
  text-align: center;
}

.inputControl {
  border: 1px solid #bfd243 !important;
  height: 30px !important;
  text-transform: uppercase;
  border-radius:5px;
}

.labelControl {
  font-size:16px;
  color:#000;
  font-weight:500;
  font-family: 'Roboto';
}

.buttonNext {
  background-color: #bfd243; /* Green */
  opacity: 0.8;
  border: none;
  border-radius: 5px;
  color: white;
  padding: 1px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
  font-weight: 700;
  font-family:'Roboto';
  widows: 10px;
  width: 100%;
  height: 30px;
  cursor: pointer;
}

.buttonWithoutBackground {
  background-color: #fff; /* Green */
  opacity: 0.8;
  border: solid 1px;
  border-radius: 5px;
  border-color: #223635;
  color: #000;
  padding: 1px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
  font-weight: 500;
  font-family:'Roboto';
  widows: 10px;
  width: 100%;
  height: 30px;
  cursor: pointer;
}
</style>